import { ASSUMPTION_TYPES, PAYMENT_TYPES } from '../../../../../core/constants';
import { RowType} from '../types';

export const INVOICE_IMPACT_INDEX = 'invoice_impact'
export const VAT_INDEX = 'VAT Payment';
export const MARGIN_LEFT_LEVEL = 16;

export const isAiAssumption = (row: RowType) => [
  PAYMENT_TYPES.AI_DAYS,
  ASSUMPTION_TYPES.AI
].includes(row.account.type as PAYMENT_TYPES | ASSUMPTION_TYPES);

export const isInvoiceAssumption = (row: RowType) => row.account.index === INVOICE_IMPACT_INDEX;

export const isVatRow = (row: RowType) => row.account.index === VAT_INDEX;
